<template>
  <el-dialog :title="$t('chainSupplierCatalog.editCatalog')" :visible.sync="dialogVisible" width="50%"
    @close="handleClose">
    <el-form :model="editChainSupplierCatalogInfo" :rules="rules" ref="form" label-width="150px">
      <el-form-item :label="$t('chainSupplierCatalog.catalogName')" prop="catalogName">
        <el-input v-model="editChainSupplierCatalogInfo.catalogName"
          :placeholder="$t('chainSupplierCatalog.catalogNamePlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('chainSupplierCatalog.intfUrlParam')" prop="intfUrlParam">
        <el-input v-model="editChainSupplierCatalogInfo.intfUrlParam"
          :placeholder="$t('chainSupplierCatalog.intfUrlParamPlaceholder')"></el-input>
      </el-form-item>

      <el-form-item :label="$t('chainSupplierCatalog.seq')" prop="seq">
        <el-input v-model="editChainSupplierCatalogInfo.seq"
          :placeholder="$t('chainSupplierCatalog.seqPlaceholder')"></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="editChainSupplierCatalog">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateChainSupplierCatalog } from '@/api/admin/chainSupplierCatalog/chainSupplierCatalogApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditChainSupplierCatalog',
  data() {
    return {
      dialogVisible: false,
      editChainSupplierCatalogInfo: {
        catalogId: '',
        catalogName: '',
        csId: '',
        intfUrlParam: '',
        seq: '',
        statusCd: '0',
        shopId: ''
      },
      rules: {
        catalogName: [
          { required: true, message: this.$t('chainSupplierCatalog.catalogNameRequired'), trigger: 'blur' },
          { max: 30, message: this.$t('chainSupplierCatalog.catalogNameMaxLength'), trigger: 'blur' }
        ],
        csId: [
          { required: true, message: this.$t('chainSupplierCatalog.supplierIdRequired'), trigger: 'blur' },
          { max: 32, message: this.$t('chainSupplierCatalog.supplierIdMaxLength'), trigger: 'blur' }
        ],
        intfUrlParam: [
          { required: true, message: this.$t('chainSupplierCatalog.intfUrlParamRequired'), trigger: 'blur' },
          { max: 64, message: this.$t('chainSupplierCatalog.intfUrlParamMaxLength'), trigger: 'blur' }
        ],
        seq: [
          { required: true, message: this.$t('chainSupplierCatalog.seqRequired'), trigger: 'blur' },
          { max: 10, message: this.$t('chainSupplierCatalog.seqMaxLength'), trigger: 'blur' }
        ],
        catalogId: [
          { required: true, message: this.$t('chainSupplierCatalog.catalogIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(chainSupplierCatalog) {
      this.dialogVisible = true
      this.editChainSupplierCatalogInfo = {
        ...chainSupplierCatalog,
        shopId: getShopId()
      }
    },
    async editChainSupplierCatalog() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return

        const { code, msg } = await updateChainSupplierCatalog(this.editChainSupplierCatalogInfo)
        if (code == 0) {
          this.$message.success(this.$t('common.saveSuccess'))
          this.dialogVisible = false
          this.$emit('success')
        } else {
          this.$message.error(msg)
        }
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    }
  }
}
</script>

<style scoped>
.el-input {
  width: 100%;
}
</style>